import { useCallback, useState } from 'react';

export interface UseTFAInputProps {
  errorMessage?: string;
  onConfirm: (code: string) => void;
  onReset?: () => void;
}

const TFA_CODE_LENGTH = 6;

export const useTFAInput = ({
  errorMessage,
  onConfirm,
  onReset,
}: UseTFAInputProps) => {
  const [code, setCode] = useState('');

  const isCodeValid = code.length === TFA_CODE_LENGTH;
  const hasError = Boolean(errorMessage);

  const onChange = useCallback(
    (value: string) => {
      setCode(value);

      if (hasError) {
        onReset?.();
      }
    },
    [hasError, onReset],
  );

  const onClick = useCallback(() => onConfirm(code), [code, onConfirm]);

  const onSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      event.stopPropagation();

      if (isCodeValid) {
        onConfirm(code);
      }
    },
    [code, isCodeValid, onConfirm],
  );

  return { hasError, isCodeValid, onChange, onClick, onSubmit };
};
